import {Component, Input, OnInit} from '@angular/core';
import {AuthenticationService} from '../../../core/services/authentication.service';
import {MatDialog, MatDialogRef} from '@angular/material';
import {SignoutDialogComponent} from '../signout-dialog/signout-dialog.component';
import {Router} from '@angular/router';
import { Constants } from '../../../shared/constants';


@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {
  @Input() userName: string;
  @Input() userId: string;
  enableExportMenu: boolean;
  enableReviewMenu: boolean;

  constructor(private authService: AuthenticationService,
              public signoutDialog: MatDialog, private router: Router) {
  }

  ngOnInit() {
    const user = this.authService.currentUserValue;
    this.enableExportMenu = ('ADMN' === user.roleTypeCode || 'OPRTN' === user.roleTypeCode);
    this.enableReviewMenu = ('ADMN' === user.roleTypeCode || 'OPRTN' === user.roleTypeCode);
  }

  openDialog(): void {
    const signoutDialogRef: MatDialogRef<SignoutDialogComponent> = this.signoutDialog.open(SignoutDialogComponent, {
      width: '350px',
      hasBackdrop: true,
      disableClose: true,
      data: {}
    });

    signoutDialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.signout();
      }
    });
  }

  signout() {
    console.log('SignOut!');
    this.authService.logout(Constants.LogoutReason_LOGOUT);
  }

  toCrisisReviewPage() {
    this.router.navigate(['/cases']);
  }

  toExportCrisisCasesPage() {
    this.router.navigate(['/tab', 0]);
  }

  toUploadCrisisCasesPage(){
    this.router.navigate(['/tab', 1]);
  }
}
